import { useQuery } from '@/lib/useQuery';

const NONE = [];

/**
 * The "What do you sell?" catalogue for SellPicker (MERCH-89, SL-090): industries with their types from
 * GET /api/platform/apply/catalog. → [{ key, label, types }], [] while loading.
 */
export default function useSellCatalog() {
  const q = useQuery('platformSellCatalog', {}, { select: (r) => (r && r.data && r.data.industries) || NONE });
  return q.data || NONE;
}
